import React from 'react';
import PropTypes from 'prop-types';
import styles from './SortBy.module.less';

const SORT_OPTIONS = {
  popularity: 'Popularity',
  dateCreated: 'Most Recent',
  title: 'Title',
  relevance: 'Relevance',
};

export default function SortBy({ selectedSort = 'popularity', clickSort }) {
  const renderSortOptions = () => {
    return Object.entries(SORT_OPTIONS).map(([key, value], i) => {
      return (
        <option value={key} key={`sort-by-option-${i}`}>
          {value}
        </option>
      );
    });
  };

  const handleChangeSort = e => {
    if (typeof clickSort === 'function') {
      clickSort(e.target.value);
    }
  };

  return (
    <div className={styles.controls}>
      <div className={styles.sortByWrapper}>
        <div className={styles.sortBy}>
          <span className={styles.text}>Sort by</span>
          {/* TODO: Make this a label */}
          <select
            className={styles.select}
            aria-label="sort by"
            value={selectedSort}
            onChange={handleChangeSort}
          >
            {renderSortOptions()}
          </select>
        </div>
      </div>
    </div>
  );
}

SortBy.propTypes = {
  selectedSort: PropTypes.string.isRequired,
  clickSort: PropTypes.func,
};
